interface GoogleStreetViewProps {
  lat: number;
  long: number;
}

//TODO implement for web
export const GoogleStreetView = ({lat, long}: GoogleStreetViewProps) => {
  return null;
};
